import { isAuthEnabled } from '#/config/auth';

/**
 * 是否具備權限碼。Auth 關閉時一律 true（開發繞過）。
 * @param {string[] | null | undefined} permissions
 * @param {string} code
 */
export function can(permissions, code) {
  if (!isAuthEnabled) {
    return true;
  }
  if (!code) {
    return true;
  }
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return false;
  }
  return permissions.includes(code);
}
